import moment from "moment";
import { axiosProxy } from "utils/axiosProxy";
import { actionTypes } from "constants/Reports/harvest/fieldScaning/harvestByVariety";
import { omitBy, isNil } from "lodash";
import uuid from "uuid/v4";

const url = "/reporting_module";

let uniqId;

export const fetchHarvestByVarietyTableData = ({
  page,
  size,
  search,
  sort = ["id,desc"],
  unpaged = false,
  filters
}) => async dispatch => {
  try {
    dispatch({ type: actionTypes.FETCH_HARVEST_BY_VARIETY_TABLE_DATA_START });
    const paramsObject = omitBy(
      {
        search,
        sort,
        page,
        size
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);

    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    uniqId = uuid();
    const res = await axiosProxy({
      method: "GET",
      params,
      uniqId,
      url: `${url}/generalBarcodes/harvestByVariety`
    });
    if (uniqId === res.config.headers["X-REQUEST-ID"]) {
      dispatch({
        type: actionTypes.SET_HARVEST_BY_VARIETY_TABLE_DATA,
        tableData: res.data
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_HARVEST_BY_VARIETY_TABLE_DATA_FAILED,
      error
    });
  }
};

export const fetchHarvestByVarietyExportData = ({
  unpaged = true,
  sort = ["id,desc"],
  filters
}) => async dispatch => {
  try {
    dispatch({
      type: actionTypes.FETCH_HARVEST_BY_VARIETY_TABLE_LIST_START
    });
    const paramsObject = omitBy(
      {
        sort,
        unpaged: true
      },
      isNil
    );
    const params = new URLSearchParams(paramsObject);
    if (Array.isArray(filters)) {
      filters.forEach(([filter, value]) => {
        const from = value.slice(0, 10);
        const to = value.slice(-10);
        return filter !== "seasons"
          ? params.append(filter, value)
          : (params.append("from", `${from}T00:00:00`),
            params.append("to", `${to}T23:59:59`));
      });
    }
    const res = await axiosProxy({
      url: `${url}/generalBarcodes/harvestByVariety`,
      params,
      method: "GET"
    });
    dispatch({
      type: actionTypes.SET_HARVEST_BY_VARIETY_TABLE_LIST,
      payload: res.data
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_HARVEST_BY_VARIETY_TABLE_LIST_FAILED,
      payload: error
    });
  }
};
